import { DeleteDocumentModalComponent } from './../../modals/delete-document-modal/delete-document-modal.component';
import { Component, Input } from '@angular/core';
import { S3Service } from 'src/app/services/health-record/other-documents/s3.service';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Document } from 'src/app/beans/health-record/other-documents.bean';
import { AnalyticsBean } from 'src/app/beans/analytics/analytics-module.bean';
import { EheAnalyticsDirective } from 'src/app/modules/shared/ehe-analytics/ehe-analytics.directive';

@Component({
	selector: 'app-document-actions',
	templateUrl: './document-actions.component.html',
})
export class DocumentActionsComponent {
	@Input() document: Document;
	analyticsData: AnalyticsBean;

	constructor(
		private s3Service: S3Service,
		public dialog: MatDialog,
		public dialogRef: MatDialogRef<DeleteDocumentModalComponent>,
		private eheAnalyticsDirective: EheAnalyticsDirective
	) {
		this.analyticsData = new AnalyticsBean();
		this.analyticsData.componentName = 'Document Actions';
		this.analyticsData.pageUrl = '/wellness/health/record';
	}

	deleteConfirmation(documentKey) {
		this.dialog.open(DeleteDocumentModalComponent, {
			data: {
				documentKey,
			},
		});
		this.analyticsData.id = 'Document Delete Confirmation';
		this.analyticsData.redirectedTo = '/wellness/health/record';
		this.analyticsData.placement = 'Document Delete Confirmation Modal';
		this.eheAnalyticsDirective.captureModalButtonData(this.analyticsData);
	}

	download(body, filename, extension) {
		this.s3Service.download(body, filename, extension);
	}
}
